/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveForwardIcon24Solid = forwardRef('TimeClockMoveForwardIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.68 4.363a7.75 7.75 0 0 1 7.659 3.178H16.5a1.25 1.25 0 1 0 0 2.5H21a1.25 1.25 0 0 0 1.25-1.25V4.037a1.25 1.25 0 1 0-2.5 0v1.255a10.25 10.25 0 1 0 1.617 10.869 1.25 1.25 0 0 0-2.284-1.015A7.75 7.75 0 1 1 10.68 4.363Z" }),
        React.createElement("path", { d: "M13 7.313a1.25 1.25 0 1 0-2.5 0v3.948a2.75 2.75 0 0 0 1.52 2.46l3.296 1.647a1.25 1.25 0 0 0 1.118-2.236l-3.296-1.648a.25.25 0 0 1-.138-.223V7.313Z" })));
});
